import { IClickEventData } from 'types/analytics';

export const TEXT_KEYS = {
    CTA_DOWNLOAD_UPLAY: 'success-page__btn__download-uplay',
    CTA_PRELOAD_GAME: 'success-page__btn__preload-game',
    CTA_DOWNLOAD_BRANDED_INSTALLER: 'success-page__btn__branded-installer'
};

export const URLS = {
    DOWNLOAD_UPLAY: 'https://ubi.li/4vxt9',
    PRELOAD_GAME: (gameId: string) => (gameId ? `uplay://open/game/${gameId}` : 'uplay://open/')
};

export const DOWNLOAD_UPLAY_ANALYTICS_ATTRIBUTES: IClickEventData = {
    location: 'page',
    category: 'download',
    action: 'download uplay'
};

export const LAUNCH_UPLAY_ANALYTICS_ATTRIBUTES: IClickEventData = {
    location: 'page',
    category: 'interaction',
    action: 'launch uplay'
};

export const BRANDED_INSTALLER_ANALYTICS_ATTRIBUTES: IClickEventData = {
    location: 'page',
    category: 'interaction',
    action: 'download branded installer'
};
